const selleasyTargetElement = document.querySelector(".selleasy-fbt-target")

// Options for the observer (which mutations to observe)
const config = { attributes: false, childList: false, subtree: false };

// Callback function to execute when mutations are observed
const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
        if (mutation.type === "childList") {
            checkAndUpdate()
        }
    }
};

// Create an observer instance linked to the callback function
const selleasyObserver = new MutationObserver(callback);

// Start observing the target node for configured mutations
if(selleasyTargetElement && config){
    selleasyObserver.observe(selleasyTargetElement, config);
}

const formatSePrice = (price) => {
    let formattedPrice = price.split(".")[0]
    
    return formattedPrice
}

const formatElementPrices = () => {
    let priceElements = document.querySelectorAll(".lb-upsell-money-2")

    priceElements.forEach(ele => {
        ele.textContent = formatSePrice(ele.textContent)
    })
}

const checkAndUpdate = () => {
    formatElementPrices()
    
    let totalBeforeSavingEle = document.querySelector(".ppcse-card-tot-price-strike-out")
    let totalAfterSavingEle = document.querySelector(".ppcse-card-tot-price")
    let footerEle = document.querySelector(".ppcse-card-tot-footer")
    let footerSavedEle = footerEle.querySelector(".ppcse-custom-saved")

    if (!totalAfterSavingEle || !totalBeforeSavingEle){
        return
    }


    let priceBefore = parseInt(totalBeforeSavingEle.textContent.replace("£", "").replace(",", ""))
    let priceAfter = parseInt(totalAfterSavingEle.textContent.replace("£", "").replace(",", ""))
    let priceSaved = priceBefore - priceAfter

    if(!footerSavedEle){
        let newFooterDivString = '<span class="custom-price-before">2000</span><span class="custom-you-save">you save <span class="custom-price-saved">$800</span></span>'
        // footerEle.innerHTML = newFooterDivString
        let newDiv = document.createElement("div")
        newDiv.classList.add("ppcse-custom-saved")
        newDiv.innerHTML = newFooterDivString
        footerEle.appendChild(newDiv)
    }

    let priceBeforeEle = document.querySelector(".custom-price-before")
    let priceSavedEle = document.querySelector(".custom-price-saved")

    if(priceBeforeEle){
        priceBeforeEle.textContent = `£${priceBefore}`
    }

    if(priceSavedEle){
        priceSavedEle.textContent = `£${priceSaved}`
    }
}